export default "__VITE_ASSET__BURuCWC7__";